<template>
  <div class="box">
    <div class="product" id="product">
      <header>
        <div>
          <img src="../assets/logo.png" alt="" />
          <span class="logoname">PT RADJA INDO REZEKI</span>
        </div>
        <nav>
          <a href="#product">Beranda</a>
          <a href="#about">Tentang kami</a>
          <a href="#partner">Jangkauan Layanan</a>
          <a href="#products">produk kami</a>

        </nav>
      </header>
      <div class="name">PT RADJA INDO REZEKI</div>
      <div class="logomsg">
        PT RADJA INDO REZEKI adalah koperasi keuangan yang dinamis dan inovatif
        yang menjadi cahaya harapan pemberdayaan keuangan bagi individu maupun
        bisnis. Dengan komitmen untuk menyediakan solusi keuangan yang cepat dan
        mudah diakses.
      </div>
      <!-- <a href="https://play.google.com/store/apps/details?id=com.bantu.cepat" class="googlelogo"></a> -->
    </div>
    <div class="about" id="about">
      <div class="title">Tentang kami<span></span></div>
      <div class="content">
        PT RADJA INDO REZEKI, kami memahami kebutuhan keuangan yang beragam dan
        terus berkembang dari para anggota kami. Nama kami, yang berarti
        "Koperasi Simpan Pinjam Dana Cair Cepat" mencerminkan tujuan utama kami
        untuk memastikan akses cepat ke dana saat dibutuhkan yang paling.
        Sebagai sebuah organisasi yang berfokus pada pengguna, kami berkomitmen
        untuk mengembangkan ketahanan keuangan, sehingga pengguna dapat mencapai
        tujuan mereka
      </div>
    </div>
    <div class="partner" id="partner">
      <h2 class="title">Keuntungan kami<span></span></h2>
      <div class="content">
        <div class="img-text">
          <img src="../assets/about-1.png" alt="" />
          <div class="text-box">
            <div class="text-title">Efisiensi</div>
            <p>
              Kami bangga dengan proses pinjaman yang efisien dan pencairan dana
              yang cepat. Kami mengerti bahwa situasi darurat dan peluang tidak
              menunggu siapa pun, dan proses kami yang efisien mencerminkan
              komitmen kami untuk memberikan dukungan keuangan tepat waktu.
            </p>
          </div>
        </div>
        <div class="img-text">
          <div class="text-box">
            <div class="text-title">Inovasi</div>
            <p>
              Kami merangkul kemajuan teknologi untuk memastikan anggota kami
              mengalami pengalaman yang lancar dan nyaman. Melalui platform
              online dan aplikasi seluler, anggota dapat mengelola akun mereka,
              mengajukan pinjaman dengan mudah.
            </p>
          </div>
          <img src="../assets/about-2.png" alt="" />
        </div>
      </div>
    </div>

    <div class="partner" id="products">
      <div class="products-box">
        <div class="products-item" :class="{ active: ProductsIndex === 1 }" @click="ProductsIndex = 1">
          <h2 class="title">PinjaminAja-Pinjaman Cepat<span></span></h2>
          <div class="title-1">
            Asisten keuangan portabel Anda, membuat pinjaman lebih mudah dan aman!
          </div>
        </div>
        <div class="products-item" :class="{ active: ProductsIndex === 2 }" @click="ProductsIndex = 2">
          <h2 class="title">สยามวอลเล็ท-สินเชื่อง่าย ๆ<span></span></h2>
          <div class="title-1">
            สินเชื่อที่ปลอดภัย ตอบโจทย์ความต้องการทางการเงินของคุณได้อย่างง่ายดาย
          </div>
        </div>
      </div>

      <div class="products-content" v-if="ProductsIndex === 1">
        <div class="content">
          <div class="img-text">
            <img src="../assets/about-7.png" alt="" />
            <div class="text-box">
              <p>
                PinjaminAja adalah platform perantara pinjaman cerdas yang
                mengintegrasikan berbagai pemberi pinjaman teregulasi. Kami
                memanfaatkan teknologi pengendalian risiko big data untuk
                merekomendasikan produk pinjaman yang sesuai, menghilangkan proses
                aplikasi yang rumit dan perjalanan yang mudah. Namun, PinjaminAja
                hanyalah platform layanan keuangan online. Dana dan produk yang
                disediakan oleh lembaga keuangan terkemuka yang bermitra dengan
                kami bersumber dari lembaga-lembaga tersebut. Oleh karena itu,
                kami tidak secara langsung menyediakan layanan pinjaman; kami
                hanya berfungsi sebagai platform untuk merekomendasikan produk
                keuangan kepada nasabah kami.
              </p>
            </div>
          </div>
          <div class="img-text">
            <div class="text-box">
              <div class="text-title">Fitur:</div>
              <p>
                1. Rekomendasi Cepat dan Tinjauan Cepat: Pengguna dapat mengunduh
                produk keuangan yang sesuai dengan OJK melalui rekomendasi
                PinjaminAja.
                <br />
                2. Berbagai Pilihan Jumlah Pinjaman: Mencakup pinjaman darurat
                kecil hingga kebutuhan pinjaman menengah, melayani berbagai
                kapasitas pembayaran.<br />
                3. Pencocokan Solusi Berkualitas Tinggi yang Cerdas: Big data
                secara akurat mencocokkan pemberi pinjaman yang paling sesuai,
                meningkatkan tingkat persetujuan.<br />
                4. Sah dan Aman, Bermitra dengan Lembaga Berlisensi: Semua lembaga
                mitra adalah lembaga keuangan resmi yang disetujui oleh regulator
                keuangan. 5. Konverter Mata Uang: Pantau konversi mata uang kapan
                pun dan di mana pun, baik saat bepergian maupun berbisnis,
                membantu Anda tetap mengikuti tren nilai tukar.<br />
                6. Penilaian Keuangan: Sesuaikan saran keuangan berdasarkan
                kepribadian keuangan Anda.<br />
                7. Informasi Keuangan: Pahami tren keuangan internasional dan
                Indonesia dan kelola kekayaan Anda.
              </p>
            </div>
            <img src="../assets/about-8.png" alt="" />
          </div>
        </div>
        <div class="content">
          <div class="img-text">
            <img src="../assets/about-3.png" alt="" />
            <div class="text-box">
              <p>
                Produk Keuangan yang Direkomendasikan: <br />
                Jumlah Pinjaman: Rp500.000-20.000.000 <br />
                Tingkat Persentase Tahunan (APR): Hingga 18% per tahun. <br />
                Jangka Waktu Pinjaman: Minimal 91 hari, maksimal 365 hari. <br />
              </p>
            </div>
          </div>
          <div class="img-text">
            <div class="text-box">
              <p>
                Contoh Pinjaman Produk Keuangan yang Direkomendasikan: <br />
                Pinjaman sebesar Rp2.000.000 dengan jangka waktu 120 hari (4
                bulan) memiliki APR sebesar 18% per tahun (suku bunga harian
                0,05%). Tidak ada biaya tambahan. Di akhir periode 120 hari, total
                pembayaran pengguna sama dengan pokok + bunga. Sebagai berikut:
                <br />
                Bunga bulanan: 2.000.000 x 0,05% x 30 = Rp30.000 <br />
                Pembayaran bulanan: 2.000.000/4 + 30.000 = Rp530.000 <br />
                Total bunga: 30.000 x 4 = Rp120.000 <br />
                Total pembayaran: 2.000.000 + 120.000 = Rp2.120.000
              </p>
            </div>
            <img src="../assets/about-4.png" alt="" />
          </div>
        </div>
        <div class="content">
          <div class="img-text">
            <img src="../assets/about-5.png" alt="" />
            <div class="text-box">
              <p>
                Persyaratan pengajuan produk keuangan:<br />
                1. Berusia 18-60 tahun (anak di bawah umur tidak memenuhi syarat
                untuk pinjaman).<br />
                2. Memiliki sumber pendapatan tetap atau tidak tetap.<br />
                3. Memiliki KTP yang sah. 4. Memiliki rekening penerima aktif atas
                nama Anda.<br />
              </p>
            </div>
          </div>
          <div class="img-text">
            <div class="text-box">
              <p>
                Hubungi kami:<br />
                Surel: admin@radjaindorezeki.com<br />
                Jam Kerja: Senin hingga Minggu, pukul 09.00 - 18.00<br />
                Alamat : RUKO CIPTALAND BLOK ANGGREK NOMOR 63, Desa/Kelurahan<br />
                Patam Lestari, Kec. Sekupang, Kota Batam, Provinsi Kepulauan
                Riau,<br />
                Kode Pos: 29427
              </p>
            </div>
            <img src="../assets/about-6.png" alt="" />
          </div>
        </div>
      </div>

      <div class="products-content" v-else-if="ProductsIndex === 2">
        <div class="content">
          <div class="img-text">
            <img src="../assets/products-1.png" alt="" />
            <div class="text-box">
              <p>
                สยามวอลเล็ท เป็นแอปพลิเคชั่นแนะนำสินเชื่อออนไลน์ที่เรียบง่าย
                ซึ่งมุ่งมั่นที่จะมอบบริการสินเชื่อที่รวดเร็วและยืดหยุ่นให้แก่ผู้ใช้
                คุณสามารถยื่นใบสมัครสินเชื่อได้อย่างง่ายดายเพียงดาวน์โหลดและกรอกข้อมูลประจำตัวประชาชนของคุณ
                เมื่อใบสมัครของคุณได้รับการอนุมัติ เงินจะถูกโอนเข้าบัญชีของคุณทันที
                เพื่อตอบสนองความต้องการเงินทุนของคุณได้อย่างรวดเร็ว
                โปรดทราบว่าแพลตฟอร์มนี้ให้บริการเฉพาะกับผู้ใช้ที่มีอายุมากกว่า 18 ปีขึ้นไปเท่านั้น
                และผู้ใช้ที่มีอายุต่ำกว่า 18 ปีไม่สามารถสมัครขอสินเชื่อได้
              </p>
            </div>
          </div>
          <div class="img-text">
            <div class="text-box">
              <div class="text-title">ข้อดีของสยามวอลเล็ท:</div>
              <p>
                1. อัตราดอกเบี้ยที่ต่ำลง<br />
                2. กระบวนการสมัครที่ง่ายขึ้น<br />
                3. อนุมัติและเบิกเงินกู้รวดเร็ว<br />
                4. วิธีการชำระเงินที่ยืดหยุ่น<br />
                5. จำนวนเงินกู้ส่วนบุคคล<br />
                6. การประเมินความเสี่ยงอัตโนมัติ
              </p>
            </div>
            <img src="../assets/products-2.png" alt="" />
          </div>
        </div>
        <div class="content">
          <div class="img-text">
            <img src="../assets/products-3.png" alt="" />
            <div class="text-box">
              <p>
                รายละเอียดสินเชื่อ:<br />
                ระยะเวลาการกู้ยืม: 91 วันถึง 180 วัน<br />
                วงเงินกู้ : ขั้นต่ำ 1,000 บาท สูงสุด 45,000 บาท<br />
                อัตราดอกเบี้ยต่ำ : อัตราดอกเบี้ยสูงถึง 18% ต่อปี (ประมาณ 0.05% ต่อวัน)<br />
                ค่าธรรมเนียมอื่นๆ : ไม่มีค่าธรรมเนียมการจัดการเพิ่มเติม
              </p>
            </div>
          </div>
          <div class="img-text">
            <div class="text-box">
              <p>
                ตัวอย่างการคำนวณสินเชื่อ:<br />
                สำหรับเงินกู้ 10,000 บาท ระยะเวลากู้ 120 วัน อัตราดอกเบี้ย 18% ต่อปี<br />
                อัตราดอกเบี้ยรายวัน : 18%/365=0.05%<br />
                ดอกเบี้ยที่ต้องชำระต่อวัน: 10,000*0.05%=5 บาท<br />
                ดอกเบี้ยจ่ายต่อเดือน : 10,000*0.05%*30=150 บาท<br />
                ยอดเงินที่ต้องชำระต่อเดือน : 10,000*0.05%*30+10,000/120*30=2,650 บาท<br />
                ดอกเบี้ยรวม : 10,000*0.05%*120=600 บาท<br />
                ยอดชำระรวม : 10,000+600=10,600 บาท<br />
                เมื่ออนุมัติสินเชื่อแล้วผู้ใช้จะได้รับเงินกู้ 10,000 บาท ไม่มีค่าธรรมเนียมแอบแฝงอื่น ๆ
                คุณเพียงต้องคืนเงินต้นและดอกเบี้ยเมื่อสินเชื่อครบกำหนด
              </p>
            </div>
            <img src="../assets/products-4.png" alt="" />
          </div>
        </div>
        <div class="content">
          <div class="img-text">
            <img src="../assets/products-5.png" alt="" />
            <div class="text-box">
              <p>
                เงื่อนไขการสมัคร:<br />
                1. มีบัตรประชาชน และมีอายุ 18 ปีบริบูรณ์ขึ้นไป (ผู้เยาว์ไม่สามารถสมัครได้)<br />
                2. ดาวน์โหลดแอพสยามวอลเล็ทจากแหล่งที่เป็นทางการ<br />
                3. บัญชีส่วนตัวที่ถูกต้อง
              </p>
            </div>
          </div>
          <div class="img-text">
            <div class="text-box">
              <p>
                ติดต่อเรา:<br />
                อีเมล: admin@radjaindorezeki.com<br />
                เวลาทำการ : จันทร์-เสาร์ 10.00-18.30 น.<br />
                ที่อยู่ : CIPTALAND RUKO ANGGREK BLOCK NUMBER 63, หมู่บ้าน Patam Lestari, เขต Sekupang, เมืองบาตัม,
                จังหวัดหมู่เกาะ Riau, อินโดนีเซีย
              </p>
            </div>
          </div>
        </div>
      </div>




    </div>
    <div class="services">
      <h2 class="title">Jangkauan Layanan<span></span></h2>
      <div class="services-box">
        <div class="services-item">
          <img src="../assets/iocn-1.png" alt="" />
          <div class="item-text">
            <div>Pinjaman Cepat</div>
            <p>
              Kami menawarkan berbagai jenis pinjaman kepada anggota kami, mulai
              dari dana darurat pribadi hingga modal ekspansi bisnis, memenuhi
              beragam kebutuhan keuangan dalam situasi yang berbeda.
            </p>
          </div>
        </div>
        <div class="services-item">
          <img src="../assets/iocn-2.png" alt="" />
          <div class="item-text">
            <div>Rencana Tabungan</div>
            <p>
              Rencana tabungan kami dirancang untuk membantu anggota dalam
              membentuk kebiasaan menabung yang sehat, memberikan dukungan
              keuangan untuk tujuan masa depan dan kejadian tak terduga.
            </p>
          </div>
        </div>
        <div class="services-item">
          <img src="../assets/iocn-3.png" alt="" />
          <div class="item-text">
            <div>Penasihat Investasi</div>
            <p>
              Tim profesional kami memberikan nasihat tentang manajemen
              portofolio investasi, manajemen risiko, dan perencanaan keuangan
              kepada anggota, membantu mereka dalam membuat keputusan keuangan
              yang terinformasi.
            </p>
          </div>
        </div>
        <div class="services-item">
          <img src="../assets/iocn-4.png" alt="" />
          <div class="item-text">
            <div>Layanan Daring</div>
            <p>
              Melalui aplikasi seluler kami, anggota dapat mengakses informasi
              akun, dan mengajukan pinjaman kapan saja, di mana saja, memastikan
              pengalaman layanan keuangan yang nyaman dan lancar.
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="img"></div>
      <div class="img2"></div> -->
    </div>

    <div class="apakah">
      <h2 class="title">Apakah saya memenuhi syarat?<span></span></h2>
      <div class="apakah-text">
        <p>1. Unduh aplikasi kami</p>
        <p>2. Daftarkan dan kirimkan informasi aplikasi</p>
        <p>3. Unggah dokumen persetujuan yang diperlukan</p>
        <p>
          4. Tunggu hasil persetujuan, jika persetujuan lolos maka Anda akan
          mendapatkan kualifikasi dan besaran pinjaman
        </p>
      </div>
    </div>
    <footer class="bottom">
      <p>
        <!-- Email: kspinjamdanacepatcair@hotmail.com -->
        <br />
        RUKO CIPTALAND BLOK ANGGREK NOMOR 63, Desa/Kelurahan Patam Lestari, Kec.
        Sekupang, Kota Batam, Provinsi Kepulauan Riau, Kode Pos: 29427
      </p>
      <div class="capyle">© 2025 PT RADJA INDO REZEKI</div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      showPrivasi: false,
      show: false,
      ProductsIndex: 1
    };
  },
  mounted() {
    if (this.$route.query.go == 1) {
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById("partner").scrollIntoView();
        }, 100);
      });
    }
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index;
      setTimeout(() => {
        this.showMenu = false;
      }, 100);
      switch (index) {
        case 0:
          document.getElementById("home").scrollIntoView();
          break;
        case 1:
          document.getElementById("step").scrollIntoView();
          break;
        case 2:
          document.getElementById("product").scrollIntoView();
          break;
        case 3:
          document.getElementById("user").scrollIntoView();
          break;
        case 4:
          document.getElementById("about").scrollIntoView();
          break;
        case 5:
          document.getElementById("privacy").scrollIntoView();
          break;
        case 6:
          document.getElementById("footer").scrollIntoView();
          break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu;
    },
    toPrivacy() {
      this.$router.push({ path: "/privacy" });
    },
  },
};
</script>
<style lang="less">
@import url("@/style/m_index.less") only screen and (max-width: 750px);
@import url("@/style/pc_index.less") only screen and (min-width: 750px);
</style>
<style scoped lang="less">
.privasi {
  margin-top: 234px;
  padding: 0;
}

.products-box {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-top: 50px;

  .products-item {
    flex: 1;
    background: linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%);
    border-radius: 12px;
    padding: 40px 30px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 2px solid transparent;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(42, 129, 216, 0.2);
      border-color: #2a81d8;
    }

    &.active {
      background: linear-gradient(135deg, #2a81d8 0%, #1e6bb8 100%);
      border-color: #2a81d8;
      box-shadow: 0 8px 20px rgba(42, 129, 216, 0.3);

      .title {
        color: #ffffff;

        span {
          background: #ffffff;
        }
      }

      .title-1 {
        color: #ffffff;
      }

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 12px 24px rgba(42, 129, 216, 0.4);
      }
    }

    .title {
      margin: 0 0 20px 0;
      font-size: 36px;
      text-align: center;
      color: #333333;

      span {
        // left: 50%;
        // transform: translateX(-50%);
        width: 100px;
        margin-bottom: 10px;
      }
    }

    .title-1 {
      font-size: 20px;
      text-align: center;
      color: #666666;
      line-height: 1.6;
      margin-top: 20px;
    }
  }
}

.products-content {
  margin-top: 60px;
  animation: fadeIn 0.5s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .content {
    margin-bottom: 60px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

// 响应式样式
@media only screen and (max-width: 750px) {
  .products-box {
    flex-direction: column;
    gap: 20px;
    margin-top: 30px;

    .products-item {
      padding: 30px 20px;

      .title {
        font-size: 28px;
        margin-bottom: 15px;
      }

      .title-1 {
        font-size: 16px;
      }
    }
  }

  .products-content {
    margin-top: 40px;

    .content {
      margin-bottom: 40px;

      .img-text {
        flex-direction: column;

        img {
          width: 100%;
          margin-bottom: 20px;
        }

        .text-box {
          width: 100%;

          p {
            width: 100%;
            font-size: 18px;
          }

          .text-title {
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
